// extracted by mini-css-extract-plugin
export default {"PdfPreview":"PdfPreview_PdfPreview__RmDBy","pages":"PdfPreview_pages__SIfVq"};